<main class="main-wrap">
    <div class="left-sidebar-wrapper">
      <app-feeds-company-details-page></app-feeds-company-details-page>
    </div>
  </main>